import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';

/**
 * @title QuickAccessState
 * @since 1.0.0
 * 
 * @description The `QuickAccessState` class manages the filter state of the activities.
 * It provides actions for setting and clearing group, lead and contact IDs, as well as a selector
 * to retrieve the current group, lead and contact IDs.
 */

export class SetQuickAccessIds {
	static readonly type = '[QuickAccess] Set IDs';
	constructor(public payload: { contactId: string, leadId: string, groupId: string }) { }
}

export class ClearQuickAccessIds {
	static readonly type = '[QuickAccess] Clear IDs';
}

export interface QuickAccessStateModel {
	contactId: string;
	leadId: string;
	groupId: string;
}

@State<QuickAccessStateModel>({
	name: 'quickAccess',
	defaults: {
		contactId: '',
		leadId: '',
		groupId: ''
	}
})
@Injectable()
export class QuickAccessState {

	/**
	 * This selector retrieves the current quick access IDs from the state.
	 * @param state The current state of the QuickAccessState.
	 * @returns {QuickAccessStateModel} The current quick access IDs.
	 * @since 1.0.0
	 */
	@Selector()
	static getQuickAccessIds(state: QuickAccessStateModel) {
		return state;
	}

	/**
	 * This action sets the quick access IDs in the state.
	 * @param ctx The state context.
	 * @param action The action containing the IDs to set.
	 * @since 1.0.0
	 */
	@Action(SetQuickAccessIds)
	setQuickAccessIds(ctx: StateContext<QuickAccessStateModel>, action: SetQuickAccessIds) {
		console.log('Setting quick access ids', action.payload);
		ctx.setState(action.payload);
	}

	/**
	 * This action clears the quick access IDs in the state.
	 * @param ctx The state context.
	 * @since 1.0.0
	 */
	@Action(ClearQuickAccessIds)
	clearQuickAccessIds(ctx: StateContext<QuickAccessStateModel>) {
		ctx.setState({
			contactId: '',
			leadId: '',
			groupId: ''
		});
	}
}